import { ConstanteGlobal } from "../config/constanteGlobal";
import { ModeloSopProduction } from "../models/sopProduction";

import { Repositorio } from "./repositorio";

export class FiltroSopProduction {
  editados = false;
  flg_aberto = false;
  num_nivel = 0;

  dth_inicio?: Date | null;
  dth_fim?: Date | null;

  cod_business_unit?: string;
  cod_region?: string;
  cod_product?: string;
  cod_product_family?: string;
  resale=false;


  cod_linha_produto_capitao?: string;
  cod_familia_subgrupo_produto_capitao?: string;
  cod_gerencia?: string;
  cod_acabamento?: string;
  cod_temperatura?: string;
  cod_mercado?: string;
  cod_tipo_produto?: string;
  cod_produto_capitao?: string;

  value?: string = "Quantity";
  cod_usuario?: string;
  constructor() {
    const today = new Date();
    this.dth_inicio = new Date(today.getFullYear(), today.getMonth() - 12, 1); // 1 ano atrás
    this.dth_fim = new Date(today.getFullYear(), today.getMonth() + 3, 1);    // 3 meses à frente
  }

}

export class RepositorioSopProduction extends Repositorio<ModeloSopProduction> {
  constructor() {
    super(ConstanteGlobal.SOP_PRODUCTION);
  }


  atualizarValor(des_atributo: string, des_valor: string, modelo: ModeloSopProduction) {
    return this.api.post(this.nomeRepositorio + "_atualizar_valor", { des_atributo, des_valor, ...modelo }).then((res) => {
      return res.data;
    });
  }

  postCards(filtro: FiltroSopProduction) {
    return this.api.post(this.nomeRepositorio + "_cards", filtro).then((res) => {
      return res.data;
    });
  }
  postProduction(filtro: FiltroSopProduction) {
    return this.api.post(this.nomeRepositorio + "_production", filtro).then((res) => {
      return res.data;
    });
  }
  postKpis(filtro: FiltroSopProduction) {
    return this.api.post(this.nomeRepositorio + "_kpis", filtro).then((res) => {
      return res.data;
    });
  }
  postRevenueRegion(filtro: FiltroSopProduction) {
    return this.api.post(this.nomeRepositorio + "_revenue_region", filtro).then((res) => {
      return res.data;
    });
  }

  


}
